import React, { useEffect, useState } from 'react';
import { getManager } from '../../api/managerApi';
import { useParams,  useNavigate } from 'react-router-dom';
import {
  managerFieldLabels,
  managerLFields,
  managerMFields,
  managerPortalPageFields,
  parseManagerSelectedMenus,
  managerToLayoutNumber,
  getManagerPortletLabelByStoredValue,
} from '../../utils/managerUtils';
import PortletLayoutPreview from '../../components/manager/PortletLayoutPreview';
import '../../css/manager.css';

const booleanRadioFields = ['M_UseExMail', 'M_UseMail', 'M_UseSSO', 'M_RedirectSSO', 'L_UseCR', 'P_UseBanner', 'P_UseCR'];
const booleanRadioFieldsEtc = ['is_active'];
const imgFields = ['L_LogoImgPath', 'L_SloganImgPath', 'P_BannerPath', 'P_LogoPath', 'P_SLogoPath'];

const displayValue = (field, value) => {
  if (booleanRadioFields.includes(field)) {
    return (value === true || value === 1 || value === '1' || value === 'true') ? '사용' : '미사용';
  }
  if (booleanRadioFieldsEtc.includes(field)) {
    return (value === true || value === 1 || value === '1' || value === 'true') ? '활성' : '비활성';
  }
  if (field === 'L_LogoType' || field === 'L_SloganType') {
    return value === 'img' ? '이미지' : value === 'text' ? '텍스트' : (value != null ? value.toString() : '-');
  }
  return value != null ? value.toString() : '-';
};

const ManagerDetail = () => {
  const { id } = useParams();
  const [manager, setManager] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getManager(id).then(setManager);
  }, [id]);

  if (!manager) return <div>로딩 중...</div>;

  const selectedLayout = managerToLayoutNumber(manager.P_PortletTypeNum);
  const selectedMenus = parseManagerSelectedMenus(manager.P_SelectMenus);

  const selectedPortletMap = (() => {
    if (!manager.P_SelectPortlet) return {};
    try {
      const parsed = typeof manager.P_SelectPortlet === 'string'
        ? JSON.parse(manager.P_SelectPortlet)
        : manager.P_SelectPortlet;
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  })();

  const getPortletLabelByZoneKey = zoneKey => {
    const raw = selectedPortletMap[zoneKey];
    return getManagerPortletLabelByStoredValue(raw);
  };

  const renderLayoutCell = (zoneKey, extraClass = '') => {
    const label = getPortletLabelByZoneKey(zoneKey);
    return (
      <div className={`layout-cell${extraClass ? ` ${extraClass}` : ''}`}>
        {label && <span className="small text-primary fw-semibold">{label}</span>}
      </div>
    );
  };

  return (
    <div className="container-fluid view-manager">
      <div className="row">
        <div className="col-12">
          {/* 상단 버튼 영역 */}
          <div className="manager-header-fixed mb-3 d-flex justify-content-between align-items-center">
            <div className="fw-bold text-dark"> {manager.M_ComName} 정보</div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate('/manager')}>목록</button>
              <button
                className="btn btn-outline-info btn-sm"
                onClick={() => navigate(`/manager/edit/${manager.M_ComCode}?mode=basic`)}
              >
                기본편집
              </button>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => navigate(`/manager/edit/${manager.M_ComCode}?mode=portlet`)}
              >
                포틀릿편집
              </button>
              <button
                className="btn btn-outline-success btn-sm"
                onClick={() => navigate(`/manager/edit/${manager.M_ComCode}?mode=menu`)}
              >
                메뉴편집
              </button>
            </div>
          </div>

          {/* M_ 필드 정보 */}
          <div className="manager-body manager-m mb-4 mt-3">
            <h6 className="fw-bold mb-3">회사 기본정보</h6>
            <div className="row">
              {managerMFields.map(field => (
                <div className="col-md-6 mb-2" key={field}>
                  <strong>{managerFieldLabels[field]}:</strong>{' '}
                  {imgFields.includes(field) && manager[field]
                    ? <img src={manager[field]} alt={field} style={{ maxHeight: '60px', maxWidth: '120px', display: 'block', marginTop: '4px' }} />
                    : displayValue(field, manager[field])
                  }
                </div>
              ))}
            </div>
          </div>

          {/* L_ 필드 정보 */}
          <div className="manager-body manager-l mb-4">
            <h6 className="fw-bold mb-3">로그인 페이지 정보</h6>
            <div className="row">
              {managerLFields.map(field => (
                <div className="col-md-6 mb-2" key={field}>
                  <strong>{managerFieldLabels[field]}:</strong>{' '}
                  {imgFields.includes(field) && manager[field]
                    ? <img src={manager[field]} alt={field} style={{ maxHeight: '60px', maxWidth: '120px', display: 'block', marginTop: '4px' }} />
                    : displayValue(field, manager[field])
                  }
                </div>
              ))}
            </div>
          </div>

          {/* P_ 필드 정보 */}
          <div className="manager-body manager-p mb-4">
            <h6 className="fw-bold mb-3">포탈 페이지 정보</h6>
            <div className="row">
              {managerPortalPageFields.map(field => (
                <div className="col-md-6 mb-2" key={field}>
                  <strong>{managerFieldLabels[field]}:</strong>{' '}
                  {imgFields.includes(field) && manager[field]
                    ? <img src={manager[field]} alt={field} style={{ maxHeight: '60px', maxWidth: '120px', display: 'block', marginTop: '4px' }} />
                    : displayValue(field, manager[field])
                  }
                </div>
              ))}
            </div>
          </div>

          <div className="manager-body manager-p mb-4">
            <h6 className="fw-bold mb-3">포탈 포틀릿 정보</h6>
            <div className="d-flex justify-content-start">
              <div style={{ width: '360px', maxWidth: '100%' }}>
                <PortletLayoutPreview layoutNum={selectedLayout} renderCell={renderLayoutCell} />
              </div>
            </div>
          </div>

          <div className="manager-body manager-p mb-4">
            <h6 className="fw-bold mb-3">좌측메뉴정보</h6>
            <div className="menu-drop-panel">
              <div className="layout-item-panel-title">선택된 메뉴</div>
              <div className="menu-drop-list">
                {selectedMenus.length === 0 && (
                  <div className="menu-drop-empty">선택된 좌측 메뉴가 없습니다</div>
                )}
                {selectedMenus.map((item, index) => (
                  <div key={item.id} className="menu-list-item menu-list-item-static">
                    <span className="menu-list-order">{index + 1}</span>
                    <span className="menu-list-label">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ManagerDetail;
